(() => {
  if (customElements.get('why-subscribe-accordion')) return;

  const DURATION = 300;

  class WhySubscribeAccordion extends HTMLElement {
    constructor() {
      super();
      this.onSummaryClick = this.onSummaryClick.bind(this);
      this.animation = null;
    }

    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.body = this.querySelector('.why-subscribe__body');
      if (!this.details || !this.summary || !this.body) return;
      this.summary.addEventListener('click', this.onSummaryClick);
    }

    disconnectedCallback() {
      this.summary?.removeEventListener('click', this.onSummaryClick);
    }

    get reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    onSummaryClick(event) {
      event.preventDefault();
      if (this.reducedMotion) {
        this.details.open = !this.details.open;
        return;
      }
      if (this.animation) this.animation.cancel();
      if (this.details.open) {
        this.shrink();
      } else {
        this.expand();
      }
    }

    expand() {
      this.details.open = true;
      const target = this.body.scrollHeight;
      this.run(0, target);
    }

    shrink() {
      const start = this.body.scrollHeight;
      this.run(start, 0, () => {
        this.details.open = false;
      });
    }

    run(from, to, onFinish) {
      this.body.style.overflow = 'hidden';
      this.animation = this.body.animate(
        { height: [`${from}px`, `${to}px`] },
        { duration: DURATION, easing: 'ease' }
      );
      this.animation.onfinish = () => {
        this.body.style.overflow = '';
        this.body.style.height = '';
        this.animation = null;
        if (onFinish) onFinish();
      };
      this.animation.oncancel = () => {
        this.body.style.overflow = '';
        this.body.style.height = '';
        this.animation = null;
      };
    }
  }

  customElements.define('why-subscribe-accordion', WhySubscribeAccordion);
})();
